/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ISchedulerHttpService } from './scheduler-http.service.interface';
import { IAppointmentResponse } from '../../models';
import { environment } from '../../../../environments/environment';

@Injectable()
export class SchedulerHttpService implements ISchedulerHttpService {
  constructor(private readonly _httpClient: HttpClient) {}

  getAppointments(driverId: number): Observable<IAppointmentResponse[]> {
    return this._httpClient.get<IAppointmentResponse[]>(
      `${environment.config.endpoints.schedulerApiEndpoint}/v2/technicians/${driverId}/visible-appointments`
    );
  }
}
